<router-outlet></router-outlet>
@for (link of links || []; track link) {
  <div class="flex flex-row justify-center mt-4">
    <a [routerLink]="link.route" class="soft-link">
      {{ link.name | translate }}
    </a>
  </div>
}
